import { format } from "date-fns";
import Icon1 from "../icons/Icon";
import { fr, is } from "date-fns/locale"; // Importing the French locale
import SmallSpinner from "../loading/SmallSpinner";
import { flutterColorToHex } from "../config/theme";
import { isColorTooDark } from "../models/OrgFunctions";
import AddressMap from "./Adressmap";
import Modal1 from "../modals/Modal1";
import { useState } from "react";

export const PlanningHeader = ({
  operators,
  selected_operators,
  handleSelectedOperators,
  handleSetDayView,
  handleClick,
  handleGoToToday,
  handleAddLunchBreak,
  loadingAddingLunchBreak,
  show_weekend,
  setShowWeekend,
  simplified_view,
  setSimplifiedView,
  appState,
  setAppState,
  planning_config,
  modal_open,
  day_view,
  currentWeekStart,
  previousWeek,
  nextWeek,
  loadingWeek,
  currentWeek,
  weekDates,
  orgData,
  getWeekNumber,
  daysOfWeek,
  workspaceData,
  events,
}) => {
  const [showMap, setShowMap] = useState({
    show: false,
    weekdate: null,
    member_id: null,
  });
  return (
    <>
      <Modal1 isOpen={showMap.show} onClose={() => setShowMap({ show: false })}>
        <div className="flex w-c600 h-c400 bg-white p-4 rounded-xl">
          <AddressMap
            items={events
              .filter(
                (event) =>
                  event.weekdate === showMap.weekdate &&
                  event.members_id &&
                  showMap.member_id &&
                  event.members_id.includes(showMap.member_id) &&
                  event.address &&
                  event.ville &&
                  event.postal
              )

              .map((event) => ({
                address:
                  event.address +
                  ", " +
                  event.ville +
                  ", " +
                  event.postal +
                  ", FRANCE",
                name: event.name || "Sans nom",
              }))}
          />{" "}
        </div>
      </Modal1>

      {day_view === null && (
        <div
          className="select-none flex flex-col sticky top-0 bg-white min-h-fit"
          style={{ zIndex: modal_open ? 1 : 8 }}
        >
          <div className=" flex flex-col  gap-1  rounded-md w-full p-1 ">
            <div className="   rounded-md flex flex-row w-full gap-4 ">
              <div className="flex  flex-row gap-1  w-fit ">
                <div
                  onClick={(e) => nextWeek(e, true)}
                  className="flex flex-row bg-white w-8 h-8 items-center  rounded-md justify-center shadow-md  cursor-pointer hover:shadow-lg border-1 border-neutral-200 hover:bg-slate-50 hover:border-indigo-300"
                >
                  <Icon1 icon_name="left" fill="blue" size={17}></Icon1>
                </div>
                <div className="flex min-w-fit select-none  flex-row bg-white border-neutral-200 border-1 w-fit  px-4 h-8 text-shadow_50 text-h3  items-center  rounded-md justify-center shadow-md ">
                  Semaine {getWeekNumber(currentWeekStart)}
                </div>
                <div
                  onClick={currentWeek}
                  className="flex select-none flex-row bg-white w-36 h-8 text-shadow_50 text-h3  items-center cursor-pointer rounded-md justify-center shadow-md hover:shadow-lg border-1 border-neutral-200 hover:bg-slate-50 hover:border-indigo-300"
                >
                  Semaine actuelle
                </div>
                <div
                  onClick={(e) => nextWeek(e, false)}
                  className="flex flex-row bg-white w-8 h-8 items-center rounded-md justify-center  shadow-md cursor-pointer hover:shadow-lg border-1 border-neutral-200 hover:bg-slate-50 hover:border-indigo-300"
                >
                  <Icon1 icon_name="right" fill="blue" size={17}></Icon1>
                </div>
                {loadingWeek && (
                  <div className="flex flex-row bg-white w-8 h-8 items-center rounded-md justify-center  shadow-md cursor-pointer hover:shadow-lg border-1 border-neutral-200 hover:bg-slate-50 hover:border-indigo-300">
                    <SmallSpinner></SmallSpinner>
                  </div>
                )}
              </div>
              <div className=" border-md flex flex-row gap-1 overflow-x-auto max-w-full  ">
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSelectedOperators("all");
                  }}
                  className={` text-nowrap  ${
                    selected_operators.includes("all")
                      ? "shadow-md bg-white text-shadow_50 "
                      : "shadow-inner bg-neutral-100 text-shadow_25"
                  }
                    flex flex-row items-center shadow-{} border-1 border-neutral-300  cursor-pointer select-none hover:shadow-md   rounded-md py-1  px-2 text-h4  justify-center`}
                >
                  Tous
                </div>
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSelectedOperators("no_operator");
                  }}
                  className={` text-nowrap  ${
                    selected_operators.includes("no_operator")
                      ? "shadow-md bg-white text-shadow_50 "
                      : "shadow-inner bg-neutral-100 text-shadow_25"
                  }
                    flex flex-row items-center shadow-{} border-1 border-neutral-300  cursor-pointer select-none hover:shadow-md   rounded-md py-1  px-2 text-h4  justify-center`}
                >
                  Sans opérateur
                </div>
                {operators

                  .sort((a, b) => {
                    return (
                      b.tracking?.last_connection?.seconds ||
                      0 - a.tracking?.last_connection?.seconds ||
                      0
                    );
                  })
                  .map((operator, index) => (
                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                        handleSelectedOperators(operator.id);
                      }}
                      className={`  text-nowrap ${
                        selected_operators.includes(operator.id)
                          ? "shadow-md bg-white text-shadow_50"
                          : "shadow-inner bg-neutral-100 text-shadow_25"
                      }
                    flex flex-row items-center shadow-{}  border-neutral-300  cursor-pointer select-none hover:shadow-md border-1  rounded-md py-1  px-2 text-h4  justify-center`}
                      key={index}
                      style={{
                        borderBlockStartColor: `${selected_operators.includes(operator.id) ? flutterColorToHex(operator.color) : "rgba(0,0,0,0.1)"}`,
                        borderBlockStartWidth: "3px",
                      }}
                    >
                      {operator.display_name.substring(0, 10)}
                    </div>
                  ))}
              </div>
              <div className="flex flex-row gap-2 justify-end flex-grow min-w-fit  ">
                <div
                  onClick={(e) => {
                    setSimplifiedView(!simplified_view);
                    let new_planning_config = { ...planning_config };
                    new_planning_config.simplified_view = !simplified_view;
                    setAppState({
                      ...appState,
                      planning_config: new_planning_config,
                    });
                  }}
                  className={`
                        ${
                          simplified_view
                            ? "shadow-md bg-white text-shadow_50"
                            : "shadow-inner bg-neutral-100 text-shadow_25"
                        }
                        flex  select-none   border-neutral-300 border-1  hover:shadow-md cursor-pointer  flex-row  px-4 w-fit h-8  text-h3  items-center  rounded-md justify-center `}
                >
                  Condensé
                </div>
                <div
                  onClick={(e) => {
                    setShowWeekend(!show_weekend);
                    let new_planning_config = { ...planning_config };
                    new_planning_config.show_weekend = !show_weekend;
                    setAppState({
                      ...appState,
                      planning_config: new_planning_config,
                    });
                  }}
                  className={`
                        ${
                          show_weekend
                            ? "shadow-md bg-white text-shadow_50"
                            : "shadow-inner bg-neutral-100 text-shadow_25"
                        }
                        flex  select-none   border-neutral-300 border-1  hover:shadow-md cursor-pointer  flex-row  px-4 w-fit h-8  text-h3  items-center  rounded-md justify-center `}
                >
                  Weekend
                </div>

                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSetDayView(0);
                  }}
                  className="flex  select-none shadow-md border-1 border-neutral-200 hover:shadow-lg  hover:border-indigo-300 cursor-pointer  flex-row bg-white  px-4 w-fit h-8 text-shadow_50 text-h3  items-center  rounded-md justify-center "
                >
                  Vue journée
                </div>
              </div>
            </div>
          </div>
          <div className="flex bg-transparent flex-row  flex-grow min-h-fit ml-10 gap-1 p-1">
            {day_view == null &&
              daysOfWeek.map((day, index) => (
                <div
                  key={day + index.toString()}
                  className={`bg-transparent cursor-pointer flex flex-row  w-1/5  font-light min-h-fit  text-h4 text-black justify-center`}
                >
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      handleSetDayView(index);
                    }}
                    className={` flex flex-col select-none w-full  border-gray-200 hover:shadow-lg border-1 hover:border-indigo-300 py-0.5  text-h4  items-center  rounded-md justify-center shadow-md  ${
                      //if this date is today, setbg-blue-100
                      weekDates[index].getDate() === new Date().getDate() &&
                      weekDates[index].getMonth() === new Date().getMonth() &&
                      weekDates[index].getFullYear() ===
                        new Date().getFullYear()
                        ? "border-b-2 border-b-indigo-400 text-indigo-400"
                        : "text-shadow_50"
                    }`}
                  >
                    <div className=" w-full   h-full flex justify-center">
                      {day}
                    </div>
                    <div
                      className={` text-h4 w-full h-full flex justify-center 
                     
                      `}
                    >
                      {/* Format the Date object to "d MMMM" (e.g., "15 Septembre") */}
                      {format(weekDates[index], "d MMMM" + " ", {
                        locale: fr,
                      })}
                    </div>
                  </div>
                  <div
                    onClick={() =>
                      setShowMap({
                        show: true,
                        weekdate: day,
                        member_id:
                          selected_operators.length === 1 &&
                          selected_operators[0] !== "all" &&
                          selected_operators[0] !== "no_operator"
                            ? selected_operators[0]
                            : null,
                      })
                    }
                    className="bg-white flex  rounded-md py-1 items-center justify-center px-2 shadow-md border hover:border-indigo-300  hover:bg-neutral-50 text-shadow_50 w-10 font-semibold  cursor-pointer"
                  >
                    <Icon1 icon_name="position" fill="grey" size={20}></Icon1>
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}

      {day_view !== null && (
        <div
          className="flex select-none flex-col sticky top-0 min-h-fit "
          style={{ zIndex: modal_open ? 1 : 8 }}
        >
          <div className=" flex flex-col  gap-1  bg-transparent rounded-md w-full p-1 ">
            <div className="   rounded-md flex flex-row w-full gap-4 ">
              <div className="flex  flex-row gap-1  w-fit ">
                <div
                  onClick={(e) => {
                    if (day_view !== 0) {
                      handleSetDayView(day_view - 1);
                    } else {
                      previousWeek(e);
                      handleSetDayView(4);
                    }
                  }}
                  className="flex flex-row  bg-white w-8 h-8 items-center  rounded-md justify-center shadow-md  cursor-pointer hover:shadow-lg border-1 hover:bg-slate-50 hover:border-indigo-300"
                >
                  <Icon1 icon_name="left" fill="blue" size={17}></Icon1>
                </div>
                <div className="flex select-none  flex-row bg-white  px-4 w-c200 h-8 text-shadow_50 text-h3  items-center  rounded-md justify-center shadow-md ">
                  {daysOfWeek[day_view] +
                    " " +
                    format(weekDates[day_view], "d MMMM" + " ", {
                      locale: fr,
                    })}
                </div>
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    handleGoToToday();
                  }}
                  className="flex flex-row select-none bg-white w-fit px-2 h-8  text-h3  items-center  rounded-md justify-center shadow-md  cursor-pointer hover:shadow-lg border-1 hover:bg-slate-50 hover:border-indigo-300"
                >
                  Aujourd'hui
                </div>
                <div
                  onClick={(e) => {
                    if (day_view !== 4) {
                      handleSetDayView(day_view + 1);
                    } else {
                      nextWeek(e);
                      handleSetDayView(0);
                    }
                  }}
                  className="flex flex-row bg-white w-8 h-8 items-center rounded-md justify-center  shadow-md cursor-pointer hover:shadow-lg border-1 hover:bg-slate-50 hover:border-indigo-300"
                >
                  <Icon1 icon_name="right" fill="blue" size={17}></Icon1>
                </div>
              </div>{" "}
              <div className=" border-md flex flex-row overflow-x-auto gap-1 flex-grow  overflow-y-auto  ">
                <div
                  onClick={() => {
                    handleSelectedOperators("all");
                  }}
                  className={`text-nowrap ${
                    selected_operators.includes("all")
                      ? "shadow-md bg-white text-shadow_50 "
                      : "shadow-inner bg-neutral-100 text-shadow_25"
                  }
                    flex flex-row  items-center shadow-{} border-1  border-neutral-300  cursor-pointer select-none hover:shadow-md   rounded-md py-1  px-2 text-h4  justify-center`}
                >
                  Tous
                </div>
                {operators.map((operator, index) => (
                  <div
                    onClick={() => {
                      handleSelectedOperators(operator.id);
                    }}
                    className={`text-nowrap ${
                      selected_operators.includes(operator.id)
                        ? "shadow-md bg-white text-shadow_50"
                        : "shadow-inner bg-neutral-100 text-shadow_25"
                    }
                    flex flex-row items-center shadow-{}  border-neutral-300  cursor-pointer select-none hover:shadow-md border-1  rounded-md py-1  px-2 text-h4  justify-center`}
                    key={index}
                    style={{
                      borderBlockStartColor: `${selected_operators.includes(operator.id) ? flutterColorToHex(operator.color) : "rgba(0,0,0,0.1)"}`,
                      borderBlockStartWidth: "3px",
                    }}
                  >
                    {operator.display_name}
                  </div>
                ))}
              </div>
              <div className="flex flex-row gap-2 justify-end flex-grow  min-w-fit">
                {!workspaceData && (
                  <div
                    onClick={handleAddLunchBreak}
                    className="flex select-none  hover:shadow-lg border-neutral-200 border-1 cursor-pointer flex-row bg-white w-fit px-4 h-8 text-shadow_50 text-h3  items-center  rounded-md justify-center shadow-md "
                  >
                    Ajouter les pauses
                    <SmallSpinner
                      loading={loadingAddingLunchBreak}
                      margin={5}
                    />
                  </div>
                )}
                <div
                  onClick={(e) => {
                    handleSetDayView(null);
                  }}
                  className="flex  select-none shadow-md hover:shadow-lg border-neutral-200 border-1 hover:border-indigo-300 cursor-pointer  flex-row bg-white  px-4 w-fit h-8 text-shadow_50 text-h3  items-center  rounded-md justify-center "
                >
                  Vue semaine
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-row gap-1 ml-10">
            {day_view != null &&
              daysOfWeek
                .filter((day, index) => index === day_view)
                .map((day, day_index) => (
                  <div
                    key={day_view}
                    className="bg-transparent  w-full select-none flex flex-col  font-light min-h-fit p-1 text-h4 text-black justify-center"
                  >
                    <div className="flex flex-row gap-1 w-full h-full">
                      {operators
                        .filter(
                          (operator) =>
                            selected_operators.includes(operator?.id) ||
                            selected_operators.includes("all")
                        )
                        .map((operator, index) => (
                          <div
                            key={index}
                            className="flex flex-col  w-full h-full "
                            onClick={(e) => {
                              handleClick(e, day_view, operator?.id);
                            }}
                          >
                            <div
                              className="bg-white rounded-md py-1 px-2  text-shadow_50 w-full font-semibold"
                              style={{
                                backgroundColor: `${flutterColorToHex(operator.color) || "black"}`,
                                color: isColorTooDark(
                                  flutterColorToHex(operator.color) || "black"
                                )
                                  ? "white"
                                  : "white",
                              }}
                            >
                              {operator.display_name}
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                ))}
          </div>
        </div>
      )}
    </>
  );
};
